<template>
  <div class="tag">
    <div class="left" v-if="$route.path === '/basicdata/tagmanagement'">
      <ul class="lable_switch">
        <li @click="checked(item.type)" :class="{'active_li' : currentType==item.type}" v-for="item in LABELData" :key="item.type">{{item.name}}</li>
      </ul>
    </div>
    <!--店铺标签-->
    <div v-if="$route.path === '/basicdata/tagmanagement' && currentType=='1'" class="right">
      <div class="operation">
        <div class="operationBtn">
          <el-button @click="delTagData()" :disabled="delDisabled">{{$t('LanguageLib.DELETE')}}</el-button>
          <el-button type="primary" @click="addPersonTag">{{$t('LanguageLib.ADD_TO')}}</el-button>
        </div>
        <div class="operationSearch">
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="searchText"
            @keyup.enter.native="searchTagList"
          >
          </el-input>
        </div>
      </div>
      <div class="tableParent">
        <el-table
          empty-text=" "
          class="table-fixed"
          :data="tableData"
          stripe
          @selection-change="selectionChange"
          @sort-change='sortChange'
          style="width: auto;"
          v-loading="loading"
          ref="listPowerSupplyTab"
          :default-sort="defaultSort"
          height="100%">
          <el-table-column
            type="selection"
            width="45"
            :selectable='selectInit'>
          </el-table-column>
          <el-table-column
            prop="sortNo"
            :label="$t('LanguageLib.SERIAL_NUMBER')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope" class="code">
              <el-tooltip class="code" effect="light" placement="top-start" >
                <span slot="content" type="sortNo">{{scope.row.sortNo}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="sortNo">{{scope.row.sortNo}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="tagName"
            :label="$t('LanguageLib.LABEL_NAME')"
            sortable="custom"
            min-width="180">
            <template slot-scope="scope" class="code">
              <el-tooltip effect="light" placement="top-start" class="code">
                <span slot="content" type="tagName">{{scope.row.tagName}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="tagName">{{scope.row.tagName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('LanguageLib.RELATED_SHOPS')"
            min-width="120">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="relationCount">{{scope.row.relationCount}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="relationCount">{{scope.row.relationCount}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('LanguageLib.Is_Enterprise_Micro_Synchronization')"
            min-width="130">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="fromQy">{{$commonfun.isQySynchronization(scope.row.fromQy)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="fromQy">{{$commonfun.isQySynchronization(scope.row.fromQy)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateDate"
            :label="$t('LanguageLib.LAST_UPDATED')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="updateDate">{{$commonfun.formatDate(scope.row.updateDate, '1')}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="updateDate">{{$commonfun.formatDate(scope.row.updateDate, '1')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('LanguageLib.Operation')"
            min-width="100">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.fromQy"
                :title="$t('LanguageLib.Edit')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#ccc;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60c;</i>
              </el-button>
              <el-button
                v-if="!scope.row.fromQy"
                @click.native.prevent="editPersonTag(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.Edit')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60c;</i>
              </el-button>
              <el-button
                @click.native.prevent="aboutStore(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.RELATED_SHOPS')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60a;</i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
    <!--人员标签-->
    <div v-if="$route.path === '/basicdata/tagmanagement' && currentType=='2'" class="right">
      <div class="operation">
        <div class="operationBtn">
          <el-button @click="delTagData()" :disabled="delDisabled">{{$t('LanguageLib.DELETE')}}</el-button>
          <el-button type="primary" @click="addPersonTag">{{$t('LanguageLib.ADD_TO')}}</el-button>
        </div>
        <div class="operationSearch">
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="searchText"
            @keyup.enter.native="searchTagList"
          >
          </el-input>
        </div>
      </div>
      <div class="tableParent">
        <el-table
          empty-text=" "
          class="table-fixed"
          :data="tableData"
          stripe
          @selection-change="selectionChange"
          @sort-change='sortChange'
          style="width: auto;"
          v-loading="loading"
          ref="listPowerSupplyTab"
          :default-sort="defaultSort"
          height="100%">
          <el-table-column
            type="selection"
            width="45"
            :selectable='selectInit'>
          </el-table-column>
          <el-table-column
            prop="sortNo"
            :label="$t('LanguageLib.SERIAL_NUMBER')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope" class="code">
              <el-tooltip class="code" effect="light" placement="top-start" >
                <span slot="content" type="sortNo">{{scope.row.sortNo}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="sortNo">{{scope.row.sortNo}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="tagName"
            :label="$t('LanguageLib.LABEL_NAME')"
            sortable="custom"
            min-width="180">
            <template slot-scope="scope" class="code">
              <el-tooltip effect="light" placement="top-start" class="code">
                <span slot="content" type="tagName">{{scope.row.tagName}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="tagName">{{scope.row.tagName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('LanguageLib.RELEVANT_PERSONNEL')"
            min-width="200">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="relationCount">{{scope.row.relationCount}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="relationCount">{{scope.row.relationCount}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('LanguageLib.BIND_ROLE')"
            min-width="200">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="roles">{{scope.row.roles}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="roles">{{scope.row.roles}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('LanguageLib.Is_Enterprise_Micro_Synchronization')"
            min-width="130">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="fromQy">{{$commonfun.isQySynchronization(scope.row.fromQy)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="fromQy">{{$commonfun.isQySynchronization(scope.row.fromQy)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateDate"
            :label="$t('LanguageLib.LAST_UPDATED')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="updateDate">{{$commonfun.formatDate(scope.row.updateDate, '1')}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="updateDate">{{$commonfun.formatDate(scope.row.updateDate, '1')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('LanguageLib.Operation')"
            min-width="140">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.fromQy"
                :title="$t('LanguageLib.Edit')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#ccc;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60c;</i>
              </el-button>
              <el-button
                v-if="!scope.row.fromQy"
                @click.native.prevent="editPersonTag(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.Edit')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60c;</i>
              </el-button>
              <el-button
                @click.native.prevent="aboutPerson(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.RELEVANT_PERSONNEL')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe602;</i>
              </el-button>
              <el-button
                v-if="!scope.row.fromQy"
                :title="$t('LanguageLib.BIND_ROLE')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#ccc;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe603;</i>
              </el-button>
              <el-button
                v-if="scope.row.fromQy"
                @click.native.prevent="personBingRole(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.BIND_ROLE')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe603;</i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
    <router-view v-if="$route.path !== '/basicdata/tagmanagement'"></router-view>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
export default {
  name: 'domainsetting',
  props: {
    msg: String
  },
  data () {
    return {
      LABELData: [
        {
          name: this.$t('LanguageLib.SHOP_LABEL'),
          type: '1'
        },
        {
          name: this.$t('LanguageLib.PERSON_LABEL'),
          type: '2'
        }
      ], // 店铺标签/人员标签
      currentType: '1', // 默认显示店铺列表
      loading: true, // loading状态
      tableData: [], // 列表数据
      pageTotal: 0, // 数据总数
      selectTagData: [], // 选中的要删除的人员数据
      selectTagDataAll: [], // 选中的要删除的人员数据
      getTagListFun: (pageIndex, pageSize, searchVal, sort, isAsc, currentType) => {
        this.loading = true
        // 请求列表接口数据
        if (currentType === '2') {
          basicdataApi.getTagList('post', '/tag/usertagpage', { pageIndex, pageSize, searchVal, sort, isAsc })
            .then(res => {
              this.tableData = res.data.data
              this.pageTotal = res.data.total
              this.loading = false
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        } else {
          basicdataApi.getTagList('post', '/tag/storetagpage', { pageIndex, pageSize, searchVal, sort, isAsc })
            .then(res => {
              this.tableData = res.data.data
              this.pageTotal = res.data.total
              this.loading = false
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }
      }, // 请求数据列表的函数
      searchText: '', // 列表搜索关键词
      currentPage: 1, // 默认显示第1页数据
      pageSize: 20, // 默认每页显示20条数据
      sort: 3, // 排序字段1：序号 2:标签名称 3：更新时间 默认传3
      isAsc: false, // 是否正序
      delDisabled: true, // 删除按钮默认禁用
      defaultSort: { prop: 'updateDate', order: 'descending' }, // 默认显示排序
      prevSort: 'descending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'updateDate', // 记录前一次的prop值
      updataRouteQuery: () => {
        const query = this.$router.history.current.query
        const path = this.$router.history.current.path
        const newQuery = JSON.parse(JSON.stringify(query))
        newQuery.currentPage = this.currentPage
        newQuery.pageSize = this.pageSize
        newQuery.searchText = this.$commonfun.encodeUrl(this.searchText)
        newQuery.sort = this.sort
        newQuery.isAsc = this.isAsc
        newQuery.currentType = this.currentType
        newQuery.NoRefresh = true
        this.$router.push({ path, query: newQuery })
      }
    }
  },
  created () {
    if (this.$route.query.currentPage) {
      this.currentPage = this.$route.query.currentPage * 1
      this.pageSize = this.$route.query.pageSize * 1
      this.searchText = this.$commonfun.decodeUrl(this.$route.query.searchText)
      this.sort = this.$route.query.sort * 1
      this.isAsc = JSON.parse(this.$route.query.isAsc)
      this.currentType = this.$route.query.currentType ? this.$route.query.currentType : '1'
      switch (this.sort) {
        case 1:
          if (this.isAsc) {
            this.defaultSort = { prop: 'sortNo', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'sortNo', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'sortNo'
          break
        case 2:
          if (this.isAsc) {
            this.defaultSort = { prop: 'tagName', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'tagName', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'tagName'
          break
        case 3:
          if (this.isAsc) {
            this.defaultSort = { prop: 'updateDate', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'updateDate', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'updateDate'
          break
      }
    }
    // 默认获取所有数据
    this.getTagListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.isAsc, this.currentType)
  },
  methods: {
    // 店铺标签/人员标签切换
    checked (type) {
      this.currentType = type
      this.pageSize = 20
      this.currentPage = 1
      this.searchText = ''
      this.sort = 3
      this.isAsc = false
      this.updataRouteQuery()
      // 店铺标签
      if (type === '1') {
        this.getTagListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.isAsc, this.currentType)
      }
      // 人员标签
      if (type === '2') {
        this.getTagListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.isAsc, this.currentType)
      }
    },
    // 企微同步的标签不允许被勾选
    selectInit (row, index) {
      if (row.fromQy) {
        return false // 不可勾选
      } else {
        return true // 可勾选
      }
    },
    // 列表排序
    sortChange (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.isAsc = true
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.isAsc = false
          this.prevSort = 'descending'
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.listPowerSupplyTab.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.isAsc = column.column.order !== 'descending'
      }
      switch (column.prop) {
        case 'sortNo':
          this.sort = 1
          break
        case 'tagName':
          this.sort = 2
          break
        case 'updateDate':
          this.sort = 3
          break
      }
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getTagListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.isAsc, this.currentType)
    },
    // 页数改变
    handleSizeChange (val) {
      this.pageSize = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getTagListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.isAsc, this.currentType)
    },
    // 每页条数改变
    handleCurrentChange (val) {
      this.currentPage = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getTagListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.isAsc, this.currentType)
    },
    // 列表模糊搜索
    searchTagList () {
      this.currentPage = 1
      this.updataRouteQuery()
      this.getTagListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.isAsc, this.currentType)
    },
    // 删除标签数据
    delTagData () {
      var count = false
      if (this.currentType === '2') {
        for (let i = 0; i < this.selectTagDataAll.length; i++) {
          if (this.selectTagDataAll[i].relationCount !== 0 || (this.selectTagDataAll[i].roles !== '' && this.selectTagDataAll[i].roles !== null)) {
            count = true
          }
        }
        if (count) {
          this.$commonfun.confirm(this.$t('LanguageLib.SELECTED_LABEL_HAVE_ROLE_OR_PERSON_ISDELETE'), this.$t('LanguageLib.DELETE_LABEL'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
            .then(() => {
              basicdataApi.delPersonTag('post', '/tag/deleteusertag', this.selectTagData)
                .then(res => {
                  this.getTagListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.isAsc, this.currentType)
                  this.$message({
                    type: 'success',
                    message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
                  })
                })
                .catch(err => {
                  this.$commonfun.console.log(err)
                })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('LanguageLib.DeletionCancelled')
              })
            })
        } else {
          this.$commonfun.confirm(this.$t('LanguageLib.ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1'), this.$t('LanguageLib.DELETE_LABEL'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
            .then(() => {
              basicdataApi.delPersonTag('post', '/tag/deleteusertag', this.selectTagData)
                .then(res => {
                  this.getTagListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.isAsc, this.currentType)
                  this.$message({
                    type: 'success',
                    message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
                  })
                })
                .catch(err => {
                  this.$commonfun.console.log(err)
                })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('LanguageLib.DeletionCancelled')
              })
            })
        }
      } else {
        for (let i = 0; i < this.selectTagDataAll.length; i++) {
          if (this.selectTagDataAll[i].relationCount !== 0 && this.selectTagDataAll[i].relationCount !== null) {
            count = true
          }
        }
        if (count) {
          this.$commonfun.confirm(this.$t('LanguageLib.SELECTED_LABEL_HAVE_STORE_ISDELETE'), this.$t('LanguageLib.DELETE_LABEL'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
            .then(() => {
              basicdataApi.delPersonTag('post', '/tag/deletestoretag', this.selectTagData)
                .then(res => {
                  this.getTagListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.isAsc, this.currentType)
                  this.$message({
                    type: 'success',
                    message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
                  })
                })
                .catch(err => {
                  this.$commonfun.console.log(err)
                })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('LanguageLib.DeletionCancelled')
              })
            })
        } else {
          this.$commonfun.confirm(this.$t('LanguageLib.ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1'), this.$t('LanguageLib.DELETE_LABEL'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
            .then(() => {
              basicdataApi.delPersonTag('post', '/tag/deletestoretag', this.selectTagData)
                .then(res => {
                  this.getTagListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.isAsc, this.currentType)
                  this.$message({
                    type: 'success',
                    message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
                  })
                })
                .catch(err => {
                  this.$commonfun.console.log(err)
                })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('LanguageLib.DeletionCancelled')
              })
            })
        }
      }
    },
    // 组织选择
    selectionChange (selection) {
      this.$commonfun.console.log(selection)
      this.selectTagData = []
      this.selectTagDataAll = []
      for (let i = 0; i < selection.length; i++) {
        this.selectTagData.push(selection[i].id)
        this.selectTagDataAll.push(selection[i])
      }
      if (this.selectTagData.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    },
    // 点击添加人员标签
    addPersonTag () {
      if (this.currentType === '2') {
        this.$router.push('/basicdata/tagmanagement/addpersontag?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&isAsc=' + this.isAsc + '&currentType=' + this.currentType + '&type=add')
      } else {
        this.$router.push('/basicdata/tagmanagement/addstoretag?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&isAsc=' + this.isAsc + '&currentType=' + this.currentType + '&type=add')
      }
    },
    // 编辑人员标签
    editPersonTag (data, index, tableData) {
      if (this.currentType === '2') {
        this.$router.push('/basicdata/tagmanagement/addpersontag?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&isAsc=' + this.isAsc + '&currentType=' + this.currentType + '&type=edit&id=' + data.id)
      } else {
        this.$router.push('/basicdata/tagmanagement/addstoretag?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&isAsc=' + this.isAsc + '&currentType=' + this.currentType + '&type=edit&id=' + data.id)
      }
    },
    // 相关人员
    aboutPerson (data, index, tableData) {
      this.$router.push('/basicdata/tagmanagement/aboutperson?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&isAsc=' + this.isAsc + '&currentType=' + this.currentType + '&id=' + data.id + '&name=' + data.tagName)
    },
    // 相关店铺
    aboutStore (data, index, tableData) {
      this.$router.push('/basicdata/tagmanagement/aboutstore?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&isAsc=' + this.isAsc + '&currentType=' + this.currentType + '&id=' + data.id + '&name=' + data.tagName)
    },
    // 绑定角色
    personBingRole (data, index, tableData) {
      this.$router.push('/basicdata/tagmanagement/personbindrole?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&isAsc=' + this.isAsc + '&currentType=' + this.currentType + '&id=' + data.id)
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
.tag{
  width:100%;
  height: 100%;
  .el-divider--vertical{
    height: 30px;
    margin: 0 10px;
  }
  .el-select{
    display: block;
    width: 100%;
  }
}
.tag .left{
  margin-top: 1px;
  background: #fff;
  width: 20%;
  float:left;
  height: 100%;
  border-right: 1px solid #f2f2f2;
  .lable_switch{
    list-style: none;
    li{
      cursor: pointer;
      height: 48px;
      line-height: 48px;
      width: calc(100% - 23px);
      padding-left: 23px;
      color: #606266;
      font-size: 14px;
    }
    .active_li{
      background: #F6F6F6;
      border: 1px solid #fff;
    }
  }
}
.tag .right{
  width: 80%;
  margin-left: 20%;
  height: 100%;
  .operation{
    background: #fff;
    height: 30px;
    padding: 10px 0 10px 20px;
    border-bottom: 1px solid #f2f2f2;
    border-top: 1px solid #f2f2f2;
    .operationBtn{
      width: auto;
      display: inline-block;
      float:left;
      position: relative;
      .el-button{
        height: 30px;
        padding: 7px 20px;
      }
    }
    .operationSearch{
      float:right;
      padding-right: 51px;
      position: relative;
      .el-input{
        width: 160px;
        .el-input__inner{
          height: 30px;
          line-height: 30px;
          border-radius: 20px;
        }
      }
      .el-icon-search{
        line-height: 30px;
      }
    }
  }
  .tableParent{
    height: calc( 100% - 98px );
  }
  .el-pagination{
    padding: 8px 15px 5px;
    height: 35px;
    background: #fff;
  }
}
.cell{
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
.el-button--primary{
  background-color:#3BC6B9;
  color:#fff;
  border:none;
  margin-left: 10px;
}
.el-button--primary:hover{
  background-color:#3BC6B9;
  color:#fff;
  border:none;
}
/*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #3BC6B9 !important;
  border-color: #3BC6B9 !important;
}*/
// 更改表格的滚动条样式
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
  background: #E1E1E1;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #fff;
}
.colorG{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(59,198,185,1);
  line-height:20px;
}
.el-table .descending .sort-caret.descending{
}
.el-table .ascending .sort-caret.ascending{
  border-bottom-color: #3BC6B9;
}
.el-pager li.active{
  color: #3BC6B9;
}
.el-table__fixed-body-wrapper .el-table__body{
    padding-bottom: 10px;
}
.filterContent{
  height: calc(100% - 116px);
  overflow: hidden;
  overflow-y: auto;
}
.filterContent::-webkit-scrollbar{
    width: 10px;
    height: 10px;
}
.filterContent::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
  background: #E1E1E1;
}
.filterContent::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #fff;
}
.el-table-column--selection{
  text-align: center !important;
}
.el-tooltip__popper.is-light{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border: 1px solid #E4E7ED !important;
  background-color: #fff;
  color: #000;
  .popper__arrow{
    border-top-color: #E4E7ED;
    border: #E4E7ED;
  }
  .popper__arrow::after{
    border-top-color: #fff;
  }
}
/*.table-fixed{
  .el-table__fixed-right{
    height:100% !important;
    right: 0 !important;
  }
  .el-table__fixed{
    height: 100% !important;
  }
}*/
</style>
